module.exports = __webpack_public_path__ + "images/02_c8413a4f.png";